import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { iconSize } from '../../../../../constants/icon.constants';
import { targetLinkdsk } from '../../../../../utils/targetDskLink';
import CTAWithArrowEditable from '../../../../@shared/CTAWithArrow/ctaWithArrow';
import Icon from '../../../../@shared/icon';
import { THeaderProps } from '../../../types/index.types';
import TableInputBox from './inputBox';

const TableHeader: FC<THeaderProps> = (props) => {
  const { t } = useTranslation();
  const {
    model,
    isDesktop,
    excelIcon,
    printTable,
    expandedRows,
    toggleAllRows,
    hideArrowButton,
    moveGridLeft,
    moveGridRight,
    searchTerm,
    setSearchTerm,
  } = props;
  return (
    <div className="model-detail-specification-table-header">
      <div className="model-detail-specification-table-header__wrapper">
        {model.eyebrow && (
          <Text field={model.eyebrow} tag="p" className="model-detail-specification-table-header__eyebrow" editable={true} />
        )}
        {(model.heading || model.link) && (
          <div className="model-detail-specification-table-header__title-link-wrapper model-detail-specification-table-header__flex">
            {model.heading && (
              <Text
                field={model.heading}
                tag={model.headingTag}
                className="model-detail-specification-table-header__title"
                editable={true}
              />
            )}
          </div>
        )}
        <div className="model-detail-specification-table-header__links-wrapper model-detail-specification-table-header__flex">
          {model?.link?.value?.href && model?.link?.value?.text && (
            <div className={'model-detail-specification-table-header__link'}>
              <CTAWithArrowEditable field={model.link} target={targetLinkdsk(model?.link, isDesktop)} />
            </div>
          )}
          {isDesktop && !model.disableExcel && (
            // special case to not use RoutableNotEditableLink
            // ignored to allow download
            // eslint-disable-next-line
            <a
              className="model-detail-specification-table-header__link--export"
              // excel to be implemented in later version
              // href={`/${APIPrefix}/download/model-specifications/${specificationUrlParameters}`}
            >
              <span className="model-detail-specification-table-header__link--export__text">{t('cnhi-excelExport')}</span>
              {excelIcon && <img className="model-detail-specification-table-header__link__icon" src={excelIcon} alt="" loading="lazy" />}
            </a>
          )}
          {isDesktop && !model.disablePrint && (
            <span className="model-detail-specification-table-header__link--print" onClick={printTable}>
              <span className="model-detail-specification-table-header__link--print__text">{t('cnhi-print')}</span>
              <Icon onClick={printTable} iconName="file-print" size={24} color="primary" />
            </span>
          )}
        </div>
        <div className="model-detail-specification-table-header__last-row model-detail-specification-table-header__flex">
          <div className="model-detail-specification-table-header__flex-wrapper">
            {!model.disableExpand && (
              <div className={'model-detail-specification-table-header__link'}>
                <button className="model-detail-specification-table-header__link--button" onClick={toggleAllRows}>
                  <Text
                    field={{
                      value: expandedRows.length === model.groupItemsIndexes.length ? t('cnhi-collapseAll') : t('cnhi-expandAll'),
                    }}
                    editable={false}
                  />
                  <Icon
                    iconName={expandedRows.length === model.groupItemsIndexes.length ? 'action-minus' : 'action-plus'}
                    size={iconSize.dsk}
                    color="primary"
                    extraClassName="table-expand-icon"
                  />
                </button>
              </div>
            )}
            {isDesktop && !model.disableSearch && (
              <span className="model-detail-specification-table-header__search-input">
                <TableInputBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
              </span>
            )}
          </div>
          {!isDesktop && !model.disablePrint && (
            <span className="model-detail-specification-table-header__link--print">
              <Icon onClick={printTable} iconName="file-print" size={20} color="primary" />
            </span>
          )}
          {!hideArrowButton && (
            <div className="model-detail-specification-table-header__arrow-wrapper">
              <div
                className="model-detail-specification-table-header__arrow model-detail-specification-table-header__arrow--left"
                onClick={moveGridLeft}
              >
                <Icon iconName="arrow-chevron-left" size={iconSize.xlg} color="primary" extraClassName="table-arrow-left" />
              </div>
              <div
                className="model-detail-specification-table-header__arrow model-detail-specification-table-header__arrow--right"
                onClick={moveGridRight}
              >
                <Icon iconName="arrow-chevron-right" size={iconSize.xlg} color="primary" extraClassName="table-arrow-right" />
              </div>
            </div>
          )}
        </div>
        {!isDesktop && !model.disableSearch && (
          <span className="model-detail-specification-table-header__search-input">
            <TableInputBox searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          </span>
        )}
      </div>
    </div>
  );
};

export default TableHeader;
